var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportgirlondesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1387.03 709.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #7b39ed;\n      }\n\n      .cls-5 {\n        fill: #231249;\n      }\n\n      .cls-6 {\n        stroke-width: .72px;\n      }\n\n      .cls-6, .cls-7 {\n        stroke: #263238;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-6, .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: #de5753;\n      }\n\n      .cls-10 {\n        fill: #e9d5ff;\n      }\n\n      .cls-2, .cls-11, .cls-12, .cls-13, .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-13 {\n        opacity: .1;\n      }\n\n      .cls-11 {\n        opacity: .4;\n      }\n\n      .cls-12, .cls-8 {\n        opacity: .2;\n      }\n\n      .cls-7 {\n        stroke-width: .5px;\n      }\n\n      .cls-14 {\n        fill: #407bff;\n      }\n\n      .cls-15 {\n        fill: #353535;\n      }\n\n      .cls-16 {\n        fill: #ffc98e;\n      }\n\n      .cls-17 {\n        fill: #e4897b;\n      }\n\n      .cls-18 {\n        fill: #263238;\n      }\n\n      .cls-3 {\n        opacity: .6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support_girl_on_desk",
    "data-name": "Support girl on desk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support_girl_on_desk-2",
    "data-name": "Support girl on desk"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m550.4,397.08l-97.84-17.33s-4.27-20.14-21.77-18.5c-17.49,1.63-85.07,37.04-85.12,50.81-.05,13.77,9.2,49.92,29.1,45.22,19.89-4.7,73.19-46.25,73.19-46.25l120.65,35.67-18.22-49.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m836.4,279.19c-3.22-2.57-7.88-2.23-10.66.81-21.62,23.57-107.47,116.82-121.14,126.33-13.69,9.53-164.79-20.9-202.55-28.69-4.55-.94-8.92,2.27-9.38,6.9l-3.98,39.43c-.37,3.65,1.82,7.07,5.31,8.23,31.93,10.63,183.75,59.67,236.95,49.07,51.73-10.3,150.26-109.33,175.36-135.29,3.22-3.33,2.85-8.67-.77-11.56l-69.14-55.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m912.24,339.77s-.7.75-2.09,2.18c-6.18,6.52-25.76,26.73-50.62,49.83-40.26,37.55-94.52,82.71-128.55,89.52-53.09,10.52-204.42-38.27-236.78-49.03-3.61-1.2-5.87-4.73-5.49-8.51l3.94-38.88c.48-4.79,4.98-8.11,9.69-7.14,38.21,7.89,188.62,38.14,202.29,28.58,13.61-9.5,99.06-102.3,120.95-126.15,2.89-3.15,7.69-3.49,11.03-.83l75.63,60.43Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.75 373.3 512.91 374.61 499.16 440.42 479.73 425.98 490.75 373.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m908.11,338.94c-5.66,6.98-23.61,28.65-46.6,53.61-18.38-33.02-4.42-89.27-4.42-89.27l51.02,35.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1058.03,148.19s9.43,88.79-23.47,110.6c-32.9,21.8-194.71-3.74-213.07-39.45-18.36-35.72,50.71-132.72,50.71-132.72l185.83,61.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1070.33 609.27 1075.07 639.92 863.2 656.26 857.59 620.01 1070.33 609.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1070.33 609.27 1075.07 639.92 863.2 656.26 857.59 620.01 1070.33 609.27"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1000.76,
    y: 606.57,
    width: 10.52,
    height: 53.6,
    transform: "translate(2071.53 1160.55) rotate(174.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 908.24,
    y: 618.46,
    width: 46.51,
    height: 35.27,
    transform: "translate(1901.87 1211.15) rotate(176.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 870.66,
    y: 612.32,
    width: 10.52,
    height: 53.6,
    transform: "translate(1812.65 1185.24) rotate(174.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1000.76,
    y: 606.57,
    width: 10.52,
    height: 53.6,
    transform: "translate(2071.53 1160.55) rotate(174.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 870.66,
    y: 612.32,
    width: 10.52,
    height: 53.6,
    transform: "translate(1812.65 1185.24) rotate(174.13)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m826.42,280.61c.94-2.56,3.72-3.91,6.36-3.19,14.42,3.92,61.19,15.05,117.48,12.16,59.33-3.05,128.8,21.72,145.51,28.07,2.24.85,3.59,3.08,3.35,5.47l-28.32,281.63c-.26,2.61-2.39,4.63-5,4.76l-203.99,10.3c-2.47.12-4.68-1.44-5.35-3.81-8.9-31.47-65.32-239.32-30.02-335.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m862.35,112.24s11.96-140.91,129.75-89.71c147.84,64.27,30.28,235.9-41.94,200.66-72.22-35.24-87.8-110.95-87.8-110.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m895.37,297.44l3.39,79.62,26.42-37.46s-9.43,88.06-3.91,136.01c0,0,5.05-85.98,17.01-136.01l28.04,37.46,40.29-79.13s-65.19-23.42-111.24-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m931.86,312.26l60.9-17.21c-37.53-25.83-18.6-83.58-18.6-83.58l-60.33,21.21c3.22,10.01,5.25,18.52,6.47,25.78,6.3,37.63-10.69,40.64-10.69,40.64l22.25,13.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m913.82,232.68c3.22,10.01,5.25,18.52,6.47,25.78,28.88-11.58,53.86-46.99,53.86-46.99l-60.33,21.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m953.2,52.11c-53.44-11.83-76.97,12.98-93.07,67.18-20.12,67.73-15.68,120,54.38,120.09,95.16.12,127.43-167.63,38.69-187.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m895.33,123.95s-10.49,12.32-20.45,18.72c0,0,2.97,8.28,12.75,9.16l7.7-27.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m929.01,126.82c-1.07,4.37.41,8.49,3.33,9.2,2.91.72,6.14-2.24,7.22-6.61,1.07-4.37-.41-8.49-3.33-9.2-2.91-.72-6.14,2.24-7.22,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m937.39,120.72l-8.58-6.06s2.76,9.15,8.58,6.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m874.95,112.55c-1.07,4.37.41,8.49,3.33,9.2,2.91.72,6.14-2.24,7.22-6.61,1.07-4.37-.42-8.49-3.33-9.2-2.91-.72-6.14,2.24-7.22,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m883.32,106.46l-8.58-6.06s2.76,9.15,8.58,6.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m937.71,90.03s15.45,1.37,21.39,13.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m899.37,79.18s-8.67-5.58-22.27-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m991.67,155.1s-15.27-49.43-3.98-82.49c0,0-96.32-66.7-125.33,39.63,0,0,10.77-97.73,103.11-79.53,92.18,18.17,62.2,152.51,5.9,182.05,0,0,29.69-28.78,20.31-59.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m980.44,164.45c2.26-8.52,14.36-21.12,29.98-15.84,16.16,5.47,16.53,41.21-26.47,40.27-6.17-.13-8.22-6.65-3.51-24.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m878.07,172.13c1.89,7.07,2.77,19.86,2.77,19.86,1.17.13,2.35.26,3.52.33,15.95,1.36,23.8-3.29,27.67-8.84,2.1-3.05,2.98-6.41,3.33-9.19.43-3.21.01-5.59.01-5.59-8.89,4.33-23.86,4.22-31.85,3.82-3.35-.13-5.45-.38-5.45-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m883.51,172.51l.97,5.83c15.03,1.24,25.78.1,30.87-4.06.43-3.21.01-5.59.01-5.59-8.89,4.33-23.86,4.22-31.85,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m884.36,192.32c15.95,1.36,23.8-3.29,27.67-8.84-5.45-.25-12.06.05-18.01,2.01-4.56,1.48-7.57,4.1-9.65,6.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m953.41,56.39s2.07,92.69,57.68,103.82c55.61,11.13-5.18-119.11-5.18-119.11,0,0-82.81-54.09-138-15.97-55.2,38.12-5.55,87.12-5.55,87.12,0,0,11.66-68.85,91.06-55.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m955.33,50.26s-19.82,58.59,19.32,89.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1027.33,179.27c-7.08,18.85-25.24,29.46-40.57,23.7-15.33-5.76-22.03-25.7-14.95-44.55,7.08-18.85,25.24-29.46,40.57-23.7,15.33,5.76,22.03,25.7,14.95,44.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1027.33,179.27c-7.08,18.85-25.24,29.46-40.57,23.7-15.33-5.76-22.03-25.7-14.95-44.55,7.08-18.85,25.24-29.46,40.57-23.7,15.33,5.76,22.03,25.7,14.95,44.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1009.62,148.37s23.03-103.17-28.65-130.22c0,0,10.77,1.45,17.45,3.4,6.68,1.95,47.96,43.79,27.1,136.52l-15.89-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1009.62,148.37s23.03-103.17-28.65-130.22c0,0,10.77,1.45,17.45,3.4,6.68,1.95,47.96,43.79,27.1,136.52l-15.89-9.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m912.71,207.42c-1.28-.17-2.56-.36-3.86-.57l1.04-6.33c46.53,7.58,81.15-17.05,81.5-17.3l3.79,5.18c-1.45,1.06-35.12,25.25-82.47,19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m912.71,207.42c-1.28-.17-2.56-.36-3.86-.57l1.04-6.33c46.53,7.58,81.15-17.05,81.5-17.3l3.79,5.18c-1.45,1.06-35.12,25.25-82.47,19.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m1025.16,176.69c-4.68,12.46-16.69,19.48-26.82,15.67-10.14-3.81-14.56-16.99-9.88-29.45,4.68-12.46,16.69-19.48,26.82-15.67,10.14,3.81,14.56,16.99,9.89,29.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m906.97,209.52l-5.15-.68c-3.82-.5-6.52-4.01-6.01-7.84h0c.5-3.82,4.01-6.52,7.84-6.01l5.15.68c3.82.5,6.52,4.01,6.01,7.84h0c-.5,3.82-4.01,6.52-7.84,6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m906.97,209.52l-5.15-.68c-3.82-.5-6.52-4.01-6.01-7.84h0c.5-3.82,4.01-6.52,7.84-6.01l5.15.68c3.82.5,6.52,4.01,6.01,7.84h0c-.5,3.82-4.01,6.52-7.84,6.01Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "976.43 272.97 938.28 310.44 953.54 356.35 1006.61 297.93 976.43 272.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "921.27 280.8 927.44 309.64 907.68 350.43 895.37 297.44 921.27 280.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m968.27,305.5l22.16-81.09s-10.74-20.2-8.42-24.43c2.32-4.22,13.85-58.67,22.07-64.6,8.22-5.93,42.02,4.19,45.44,9.71,3.42,5.52-32.39,79.31-32.39,79.31l-13.05,87.85-35.81-6.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1099.51,319.1c60.96,62.4-61.23,203.77-131.24,197.74-70.01-6.02,1.75-262.36,1.75-262.36l44.84,7.38s-15.73,110.93-10.77,119.64c4.96,8.7,74.94-83.37,95.43-62.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1099.51,319.1c60.96,62.4-61.23,203.77-131.24,197.74-70.01-6.02,1.75-262.36,1.75-262.36l44.84,7.38s-15.73,110.93-10.77,119.64c4.96,8.7,74.94-83.37,95.43-62.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "966.33 246.29 959.69 267.45 1022.16 272.97 1022.16 254.49 966.33 246.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 841.28,
    y: 413.93,
    width: 35.47,
    height: 57.92,
    rx: 0.79,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 843.39,
    y: 417.74,
    width: 28.79,
    height: 39.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 855.25,
    y: 399.96,
    width: 6.35,
    height: 23.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1097.81,
    width: 289.22,
    height: 160.97,
    rx: 5.07,
    ry: 5.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1175.31 142.62 1107.78 234.42 1216.74 148.78 1175.31 142.62"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1177.84,80.49c0,5.23-4.24,9.47-9.47,9.47s-9.47-4.24-9.47-9.47,4.24-9.47,9.47-9.47,9.47,4.24,9.47,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1227.21,80.49c0,5.23-4.24,9.47-9.47,9.47s-9.47-4.24-9.47-9.47,4.24-9.47,9.47-9.47,9.47,4.24,9.47,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1276.57,80.49c0,5.23-4.24,9.47-9.47,9.47s-9.47-4.24-9.47-9.47,4.24-9.47,9.47-9.47,9.47,4.24,9.47,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1325.94,80.49c0,5.23-4.24,9.47-9.47,9.47s-9.47-4.24-9.47-9.47,4.24-9.47,9.47-9.47,9.47,4.24,9.47,9.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.69,
    y: 590.01,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 110.69,
    y: 590.01,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 110.69,
    y: 590.01,
    width: 102.64,
    height: 49.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "110.69 597.21 327.63 597.21 110.69 603.34 110.69 597.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "354.4 605.88 166.35 610.54 354.4 610.54 354.4 605.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "120.63 619.85 213.33 616.04 349.65 619.85 213.33 621.97 120.63 619.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "110.69 630.44 271.33 630.44 110.69 634.25 110.69 630.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "354.05 634.25 246.78 636.24 354.4 636.24 354.05 634.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.78,
    y: 540.02,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 76.78,
    y: 540.02,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 76.78,
    y: 540.02,
    width: 102.64,
    height: 49.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "76.78 547.22 293.72 547.22 76.78 553.36 76.78 547.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.49 555.9 132.43 560.56 320.49 560.56 320.49 555.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "86.71 569.87 179.42 566.06 315.73 569.87 179.42 571.99 86.71 569.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "76.78 580.45 237.41 580.45 76.78 584.26 76.78 580.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.14 584.26 212.86 586.25 320.49 586.25 320.14 584.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.6,
    y: 490.04,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 104.6,
    y: 490.04,
    width: 243.71,
    height: 49.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 104.6,
    y: 490.04,
    width: 102.64,
    height: 49.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.6 497.24 321.54 497.24 104.6 503.38 104.6 497.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "348.31 505.92 160.26 510.57 348.31 510.57 348.31 505.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "114.54 519.89 207.24 516.08 343.56 519.89 207.24 522 114.54 519.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.6 530.47 265.24 530.47 104.6 534.28 104.6 530.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "347.96 534.28 240.69 536.27 348.31 536.27 347.96 534.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "510.67 638.94 517 615 777.36 615 897.26 626.97 901.82 638.94 510.67 638.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "777.36 615 777.36 638.94 510.67 638.94 517 615 777.36 615"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m725.06,500.36c1.16,12.65-8.09,22.92-20.67,22.92h-398.84c-12.65,0-23.82-10.27-24.98-22.92l-23.69-255.34c-.26-2.63-.06-5.14.51-7.45,2.25-8.99,10.14-15.47,20.16-15.47h398.84c12.65,0,23.82,10.27,24.98,22.92l23.69,255.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m702.97,523.28h-397.43c-12.65,0-23.82-10.27-24.98-22.92l-23.69-255.34c-.26-2.63-.06-5.14.51-7.45h397.43c12.58,0,23.76,10.27,24.98,22.92l23.69,255.34c.26,2.63.06,5.14-.51,7.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "428.96 366.67 511.47 366.67 489.48 602.9 619.95 622.49 619.95 638.94 345.16 638.94 345.16 622.49 401.45 602.9 428.96 366.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "511.47 366.67 450.34 635.19 401.45 633.74 428.96 366.67 511.47 366.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m38.26,660.28h1162.63v47.12c0,1.19-.97,2.16-2.16,2.16H40.42c-1.19,0-2.16-.97-2.16-2.16v-47.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m38.26,660.28h1162.63v47.12c0,1.19-.97,2.16-2.16,2.16H40.42c-1.19,0-2.16-.97-2.16-2.16v-47.12h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 38.26,
    y: 660.28,
    width: 1162.63,
    height: 24.64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m1225.27,666.71H13.88c-7.67,0-13.88-6.22-13.88-13.88h0c0-7.67,6.22-13.88,13.88-13.88h1211.39c7.67,0,13.88,6.22,13.88,13.88h0c0,7.67-6.22,13.88-13.88,13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1225.27,666.71H13.88c-7.67,0-13.88-6.22-13.88-13.88h0c0-7.67,6.22-13.88,13.88-13.88h1211.39c7.67,0,13.88,6.22,13.88,13.88h0c0,7.67-6.22,13.88-13.88,13.88Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m938.65,596.18l14.92-22.34c2.98-4.45,7.98-7.13,13.33-7.13h18.9c1.58,0,3.14.23,4.65.69l67.34,20.41c3.83,1.16,7.09,3.71,9.13,7.15l9.66,16.24-137.93-15.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1076.58,611.21l-98.04-10.66-39.87-4.37,14.9-22.34c2.95-4.43,7.96-7.13,13.35-7.13h18.88c1.61,0,3.15.26,4.69.71l1.48.45,65.81,19.97c3.85,1.16,7.13,3.66,9.18,7.13l9.63,16.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1076.58,611.21l-98.04-10.66,13.42-32.68,65.81,19.97c3.85,1.16,7.13,3.66,9.18,7.13l9.63,16.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1123.19,636.82v2.12h-208.15l7.7-30.11c3.02-11.3,13.29-19.2,24.98-19.2h92.33c3.08,0,6.1.51,8.99,1.61l11.56,4.3,45.84,17.08c10.08,3.79,16.76,13.42,16.76,24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m1123.19,636.82v2.12h-85.46l4.56-32.55c1.22-8.6,10.14-13.87,18.3-10.85l45.84,17.08c10.08,3.79,16.76,13.42,16.76,24.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m1051.05,616.81l27.19-81.59c1.17-3.52,5.21-5.17,8.51-3.46h0c2.52,1.3,3.79,4.17,3.07,6.91l-22.9,87.1s-15.24,6.16-15.87-8.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "938.65 632.16 926.59 632.16 928.92 620.31 940.98 620.31 938.65 632.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "956.64 631.7 944.58 631.7 946.91 619.85 958.97 619.85 956.64 631.7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportgirlondesk);
export default __webpack_public_path__ + "static/media/Support girl on desk.939342459e44dbae2734a90bb2184c91.svg";
export { ForwardRef as ReactComponent };